var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('accept-terms-of-service-dialog'),_c('legal-notice-dialog'),_c('terms-of-service-dialog'),_c('version-change-log')],1)}
var staticRenderFns = []

export { render, staticRenderFns }